import { SET_CMS_PAGES } from "../actions/constants";
import { createReducer } from "../../../_common/common.ts";

export const cms_pages = createReducer(null, {
    [SET_CMS_PAGES]: (state, payload)=> payload,
});